module.exports = __webpack_public_path__ + "assets/img/feature_02.133aaa38.png";